import React, { useRef } from "react";
// @ts-ignore
import mainMobileFighure from "../Assets/Images/landingpages-webp/PARHO-LANDING-PAGE-without-bg.webp";
import "../scss/LandingSubscription.scss";
// @ts-ignore
import discountLogo from "../Assets/Images/jazz-landing-logo.webp";
import { BsClockHistory } from "react-icons/bs";
// @ts-ignore
import image3gb from "../Assets/Images/landingpages-webp/three-gb-image.webp";

export interface LandingOTPProps {
  msisdn: string;
  subscribe: (otp: string[]) => void;
  error: {
    Error: string;
    isTrue: boolean;
  };
  otp: string[];
  onChangeOtp: (value: string, index: number) => void;
  resendOtp: () => void;
  miniLoading: boolean;
  timer: number;
  handleResendOTP: () => void;
  parameters: string;
}

const LandingOTP: React.FC<LandingOTPProps> = (props) => {
  const inputRef1 = useRef<HTMLInputElement>(null);
  const inputRef2 = useRef<HTMLInputElement>(null);
  const inputRef3 = useRef<HTMLInputElement>(null);
  const inputRef4 = useRef<HTMLInputElement>(null);

  const parameter = props.parameters ? props.parameters.toLowerCase() : "";

  return (
    <>
      <div className="main-content">
        <div className="images">
          <img
            className="landing-logo"
            // @ts-ignore
            fetchPriority="high"
            src={discountLogo}
            alt="logo"
          />
          <img
            width="375"
            height="390"
            src={parameter === "3gb" ? image3gb : mainMobileFighure}
            alt="Landing Image"
          />
        </div>

        <div className="landing_subscription_form pin-form">
          <div className="enter-otp">Enter OTP</div>
          <div className="otp-form">
            <div className="number_taken_inputcol otp_input">
              <input
                required
                placeholder=""
                className="mobile-verify pass m_l_0 move-next b-shadow otp"
                type="tel"
                ref={inputRef1}
                value={props.otp[0] || ""}
                onChange={(val) => {
                  const value = val.target.value;
                  if (value.trim().length > 0) {
                    const numbers = /^[-+]?[0-9]+$/;
                    if (value.match(numbers)) {
                      inputRef2.current?.focus();
                      props.onChangeOtp(value, 0);
                    }
                  }
                }}
                onKeyDown={(e) => {
                  if (props.otp[0] && props.otp[0].length !== 0) {
                    props.onChangeOtp("", 0);
                  } else if (!props.otp[0] || props.otp[0].length === 0) {
                    if (e.key === "Backspace" || e.keyCode === 8) {
                      inputRef1.current?.focus();
                    }
                  }
                }}
                maxLength={1}
              />
              <input
                required
                placeholder=""
                className="mobile-verify pass m_l_0 move-next b-shadow otp"
                type="tel"
                ref={inputRef2}
                value={props.otp[1] || ""}
                onChange={(val) => {
                  const value = val.target.value;
                  if (value.trim().length > 0) {
                    const numbers = /^[-+]?[0-9]+$/;
                    if (value.match(numbers)) {
                      inputRef3.current?.focus();
                      props.onChangeOtp(value, 1);
                    }
                  }
                }}
                onKeyDown={(e) => {
                  if (props.otp[1] && props.otp[1].length !== 0) {
                    props.onChangeOtp("", 1);
                  } else if (!props.otp[1] || props.otp[1].length === 0) {
                    if (e.key === "Backspace" || e.keyCode === 8) {
                      inputRef1.current?.focus();
                    }
                  }
                }}
                maxLength={1}
              />
              <input
                className="mobile-verify pass m_l_0 move-next b-shadow otp"
                required
                type="tel"
                placeholder=""
                ref={inputRef3}
                value={props.otp[2] || ""}
                onChange={(val) => {
                  const value = val.target.value;
                  if (value.trim().length > 0) {
                    const numbers = /^[-+]?[0-9]+$/;
                    if (value.match(numbers)) {
                      inputRef4.current?.focus();
                      props.onChangeOtp(value, 2);
                    }
                  }
                }}
                onKeyDown={(e) => {
                  if (props.otp[2] && props.otp[2].length !== 0) {
                    props.onChangeOtp("", 2);
                  } else if (!props.otp[2] || props.otp[2].length === 0) {
                    if (e.key === "Backspace" || e.keyCode === 8) {
                      inputRef2.current?.focus();
                    }
                  }
                }}
                maxLength={1}
              />
              <input
                ref={inputRef4}
                autoComplete="off"
                required
                type="tel"
                placeholder=""
                className="mobile-verify pass m_l_0 move-next b-shadow otp"
                value={props.otp[3] || ""}
                onChange={(val) => {
                  const value = val.target.value;
                  if (value.trim().length > 0) {
                    const numbers = /^[-+]?[0-9]+$/;
                    if (value.match(numbers)) {
                      props.onChangeOtp(value, 3);
                      if (
                        props.otp[0] !== "" &&
                        props.otp[1] !== "" &&
                        props.otp[2] !== ""
                      ) {
                        inputRef4.current?.blur();
                      }
                    }
                  } else if (props.otp[3] && props.otp[3].length !== 0) {
                    props.onChangeOtp("", 3);
                  }
                }}
                onKeyDown={(e) => {
                  if (!props.otp[3] || props.otp[3].length === 0) {
                    if (e.key === "Backspace" || e.keyCode === 8) {
                      inputRef3.current?.focus();
                    }
                  }
                }}
                maxLength={1}
              />
            </div>
            <div className="otp-heading-wrapper" style={{ marginTop: "10px" }}>
              {props.error.isTrue ? (
                <small className="text-red">
                  {props.error.Error}
                  <br />
                </small>
              ) : null}
              <strong className="otp-heading">
                <span className="server-response otp_instructions">
                  Didn’t Receive OTP?
                </span>
                <span>
                  {props.timer > 0 ? (
                    <span className="timer-span">
                      {" "}
                      <BsClockHistory
                        size={14}
                        style={{ marginRight: "3px" }}
                      />
                      00:{props.timer < 10 ? `0${props.timer}` : props.timer}
                    </span>
                  ) : (
                    <span className="resend_otp">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        id="resendOTP"
                        style={{ marginLeft: "4px", cursor: "pointer" }}
                        onClick={() => {
                          props.resendOtp();
                          props.handleResendOTP();
                        }}
                      >
                        Resend OTP
                      </a>
                    </span>
                  )}
                </span>
              </strong>
            </div>

            {props.miniLoading ? (
              <button className="submit-ot mb-block ajax_button_submit">
                <div
                  className="spinner-border text-white spinner-border-sm m-2"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </button>
            ) : (
              <button
                className="submit-ot"
                disabled={
                  props.otp[0] === "" ||
                  props.otp[1] === "" ||
                  props.otp[2] === "" ||
                  props.otp[3] === ""
                }
                onClick={() => {
                  props.subscribe(props.otp);
                }}
              >
                Subscribe
              </button>
            )}

            <p className="p-pricing" id="p-price-heading">
              <span>*</span> Only for Rs. 6+Tax/Day (Prepaid) & Rs.
              35.86+Tax/Month (Postpaid) *<span>*</span>
            </p>
            <div className="links" id="links-id">
              <a href="/privacypolicy" target="_blank" rel="noreferrer">
                Privary Policy
              </a>
              <span></span>
              <a href="/terms" target="_blank" rel="noreferrer">
                Terms &amp; Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(LandingOTP);
